import { WebSocketReceiveMessage } from './web-socket-receive-message';
import { exists } from '../../../../functions/exists';

export abstract class WebSocketReceiveWithSigningUserId extends WebSocketReceiveMessage {
  override payload: {
    SigningUserId: string;
  };

  public isMessageFromDifferentUser(userId: string): boolean {
    const signingUserId = this.payload?.SigningUserId;
    return !signingUserId || signingUserId !== userId;
  }

  // asset writes include SigningUserId; non-asset updates (e.g. menu name) do not
  public isAssetWriteFromUser(userId: string): boolean {
    const signingUserId = this.payload?.SigningUserId;
    return exists(signingUserId) && signingUserId === userId;
  }
}
